import React from 'react';
import { useTranslation } from 'react-i18next';

import setSidebarActiveTabByNameOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabByNameOperation';
import setSidebarActiveTabOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabOperation';
import isSidebarTabActive from 'editor/src/store/editorModules/sidebar/selector/isSidebarTabActive';
import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import Tab from 'editor/src/component/DesktopSidebar/Tabs/Tab/index';
import IconSpreadTemplates from 'editor/src/component/Icon/IconSpreadTemplates';
import useMobileMenu from 'editor/src/component/useMobileMenu';

function TemplatesTab() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const topMenu = useMobileMenu();

  const active = useSelector((state) => isSidebarTabActive(state, TAB_NAMES.DESIGN_TEMPLATES));

  const onMobileClick = () => {
    if (active) {
      dispatch(setSidebarActiveTabOperation(-1));
    } else {
      dispatch(setSidebarActiveTabByNameOperation(TAB_NAMES.DESIGN_TEMPLATES));
    }
    topMenu.close();
  };

  return (
    <Tab
      key={TAB_NAMES.DESIGN_TEMPLATES}
      name={TAB_NAMES.DESIGN_TEMPLATES}
      title={t('Templates')}
      icon={<IconSpreadTemplates />}
      onMobileClick={onMobileClick}
    />
  );
}

export default React.memo(TemplatesTab);
